import React from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, Plus } from '@opendate-app/setlist';

import { PRESALE_PRESETS } from '../utils/presaleWindows';

const AddWindowPicker = ({ showActivities, disabled, onPick }) => {
  const has = (name) => showActivities.some((activity) => activity.name === name);
  const trigger = <Button variant="link-color" icon={Plus} disabled={disabled}>Add a sales window</Button>;

  if (disabled) return trigger;

  const items = [
    ...PRESALE_PRESETS.map((preset) => {
      const available = has(preset.startName);
      return {
        key: preset.kind,
        label: preset.label,
        disabled: !available,
        description: available ? `Starts at ${preset.startName}` : `Add a ${preset.startName} show detail first`,
        onClick: () => onPick(preset),
      };
    }),
    { key: 'custom', label: 'Custom window…', onClick: () => onPick(null) },
  ];

  return (
    <Menu
      trigger={trigger}
      items={items}
      minWidth={320}
      header={(
        <div className="add-window-picker-heading">
          <span>What kind of window?</span>
          <span className="add-window-picker-step">STEP 1 OF 2</span>
        </div>
      )}
    />
  );
};

AddWindowPicker.propTypes = {
  showActivities: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired })).isRequired,
  disabled: PropTypes.bool,
  onPick: PropTypes.func.isRequired,
};

AddWindowPicker.defaultProps = { disabled: false };

export default AddWindowPicker;
